import clsx from "clsx";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { navPaths } from "../../../../constants/navbar.constants";
import { useAccountV2 } from "../../../../components/Hooks/useRegisterV2";
import WS from "../../../../config/websocketWrapper";
import { useBirdBattle } from "../../../../store/useBirdBattle";
import { sleep } from "../../../../utils/time";
import PlayerItem from "../PlayerItem";
import StopWatch from "./StopWatch";
import { toast } from "react-toastify";
import { navPaths } from "../../../../constants/navbar.constants";
import BaseBtn from "../BaseBtn";
import ModalContainer from "../../../../components/common/ModalContainer";
import ConfirmLeaveRoomModal from "../Modal/ConfirmLeaveRoom";

const PublicMatchMaking = ({
  ws,
  setMatchMaking,
  setInGameMessage,
  setYouReady,
  setAttackResponse,
  setMessage,
  setReady,
  setTurn,
  setMatchFound,
  allPlayerAccepted,
  setRematch,
  setReconnecting,
}: {
  ws: WS;
  setMatchMaking: Dispatch<SetStateAction<boolean>>;
  setInGameMessage: Dispatch<SetStateAction<number>>;
  setYouReady: Dispatch<SetStateAction<boolean>>;
  setAttackResponse: Dispatch<SetStateAction<any>>;
  setMessage: Dispatch<SetStateAction<any>>;
  setReady: Dispatch<SetStateAction<boolean>>;
  setTurn: Dispatch<SetStateAction<number>>;
  setMatchFound: Dispatch<SetStateAction<boolean>>;
  allPlayerAccepted: boolean;
  setRematch: Dispatch<SetStateAction<boolean>>;
  setReconnecting: Dispatch<SetStateAction<boolean>>;
}) => {
  const tele = window.Telegram.WebApp;
  const navigate = useNavigate();
  const { accountV2 } = useAccountV2();
  // const tele = window.Telegram.WebApp;
  // const telegramID = tele?.initData?.replaceAll("&", "%26");

  const joinRoomCode = useBirdBattle((state: any) => state.joinRoomCode);
  const playWithFrens = useBirdBattle((state: any) => state.playWithFrens);
  const setPlayWithFrens = useBirdBattle(
    (state: any) => state.setPlayWithFrens,
  );

  const updateMatch = useBirdBattle((state: any) => state.updateMatch);
  const match = useBirdBattle((state: any) => state.match);

  // const currentState = useBirdBattle((state: any) => state.currentState);
  // console.log("currentState", currentState);

  const updateCurrentState = useBirdBattle(
    (state: any) => state.updateCurrentState,
  );

  const roomType = useBirdBattle((state: any) => state.roomType);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  useEffect(() => {
    if (!ws) {
      return;
    }

    ws.setOnReconnectCallback(() => {
      setReconnecting(true); // Show loading while fetching current state
      console.log("Reconnected! Fetching current state...");
      handleCurrentState();
    });
    // Fetch the current state when the component mounts
    // handleCancelMatchmaking();
    handleCurrentState();
    // Optionally, clean up WebSocket connection on unmount if necessary
    return () => {
      ws.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ws]);

  const handleCurrentState = () => {
    ws.currentState(Date.now())
      .then(async (response: any) => {
        // Reconnect if match is in progress
        const matchId = response?.data?.current_match_id;
        if (matchId) {
          const matchData = response?.data?.current_match;

          const red_status = matchData?.red_status;
          const blueStatus = matchData?.blue_status;

          setInGameMessage({ ...matchData, current_match_id: matchId });
          // handleForfeit(matchId);

          // const redAttack = response?.data?.current_match?.red_attack;
          // const blueAttack = response?.data?.current_match?.blue_attack;
          const allPlayerAccepted =
            red_status === "accepted" && blueStatus === "accepted";
          const playerAccepted = allPlayerAccepted
            ? allPlayerAccepted
            : (red_status === "accepted" &&
                blueStatus === "build_lineup_done") ||
              (blueStatus === "accepted" && red_status === "build_lineup_done");

          setTurn(matchData?.step);

          toast.info("Reconnecting to your unfinished match!", {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 1000,
            toastId: "in-match",
          });
          !playerAccepted && setRematch(true);
          updateMatch(response?.data);
          handleSubscribeMatch(matchId, true);
          handleGetUserInfo(response?.data?.current_match);
          setMatchMaking(false);
          !playerAccepted && setReady(true);
          return;
        }

        // Reconnect if frens match is in progress
        const frensRoomCode = response?.data?.code;
        if (frensRoomCode) {
          toast.info("Reconnecting to your unfinished match!", {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 1000,
            toastId: "in-match-frens",
          });
          setPlayWithFrens(true);
          updateMatch(response?.data?.room_custom);
          handleGetUserInfo(response?.data?.room_custom);
          handleSubscribe(true, true);
          // handleLeaveRoom(frensRoomCode);
          return;
        }
        // setCurrentState(response);
        updateCurrentState(response?.data);
        handleSubscribe();
      })
      .catch((error: any) => {
        console.error("Error fetching current state:", error);
      })
      .finally(() => {
        setReconnecting(false);
      });
  };

  const [allFriendsReady, setAllFriendsReady] = useState<boolean>(false);
  const setJoinRoomCode = useBirdBattle((state: any) => state.setJoinRoomCode);

  const handleSubscribe = (
    reconnectFrens?: boolean,
    playWithFrensArg?: boolean,
  ) => {
    const playWithFrensCheck = playWithFrens || playWithFrensArg;
    ws.subscribe(
      {
        id: Date.now(),
        method: "subscribe",
        params: [playWithFrensCheck ? "custom" : "matchmaking"],
      },
      (message) => {
        if (
          playWithFrensCheck &&
          message?.data?.code &&
          !message?.data?.current_match_id
        ) {
          handleGetUserInfo(message?.data);
          updateMatch(message?.data);
        }
        if (message?.data?.current_match_id) {
          playWithFrensCheck && setAllFriendsReady(true);
          playWithFrensCheck && setInGameMessage(message?.data?.current_match);
          playWithFrensCheck && setJoinRoomCode("");
          updateMatch(message?.data);
          setMatchFound(true);
          handleSubscribeMatch(message?.data?.current_match_id);
          handleGetUserInfo(message?.data?.current_match);
          // handleGetOpponent(message?.data?.current_match);
          // handleCurrentState();
        }
        setMessage(message);
      },
    )
      .then(() => {
        if (playWithFrensCheck) {
          if (reconnectFrens) {
            return;
          }
          if (joinRoomCode) {
            handleJoinRoom();
            return;
          }
          handleCreateRoom();
          return;
        }
        handleStartMatchmaking();
      })
      .catch((error) => {
        console.error("Subscription failed:", error);
      });
  };

  // const handleUnsubscribe = () => {
  //   ws.unsubscribe({ id: id, method: "unsubscribe", params: ["matchmaking"] })
  //     .then(() => {
  //       console.log("Unsubscribed successfully");
  //       setId((prev) => prev + 1);
  //     })
  //     .catch((error) => {
  //       console.error("Unsubscribe failed:", error);
  //     });
  // };

  const handleCreateRoom = () => {
    ws.createRoom({
      id: Date.now(),
      method: "create-room",
      // params: ["11689874-d780-44b4-b859-077764e9bc89"], // Replace with any room type ID
    })
      .then(async (response) => {
        if (response?.code !== 0) {
          if (response?.message === "illegal action") {
            // handleLeaveRoom();
          }
          toast.info(response?.message, {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 2000,
            toastId: response?.message,
          });
          await sleep(2000);
          navigate(navPaths.BATTLE_HOME);
        }
        if (response?.data?.code) {
          updateMatch(response?.data);
          handleGetUserInfoFrens();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleLeaveRoom = (code: string) => {
    ws.leaveRoom({
      id: Date.now(),
      method: "leave-room",
      params: [code],
    })
      .then(async (response) => {
        if (response?.code !== 0) {
          toast.info(response?.message, {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 2000,
            toastId: response?.message,
          });
          await sleep(2000);
          return;
        }
        updateMatch(null);
        updateUsers([]);
        navigate(navPaths.BATTLE_HOME);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleJoinRoom = () => {
    ws.startMatchmaking({
      id: Date.now(),
      method: "join-room",
      params: [joinRoomCode],
    })
      .then(async (response) => {
        if (response?.code !== 0) {
          toast.info(response?.message, {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 2000,
            toastId: response?.message,
          });
          await sleep(2000);
          navigate(navPaths.BATTLE_HOME);
        }
        // setCurrentState(response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSubscribeMatch = (matchId?: string, rematch?: boolean) => {
    ws.subscribe(
      {
        id: rematch ? 1 : Date.now(),
        method: "subscribe",
        params: [`match:${matchId ? matchId : match?.current_match_id}`],
      },
      (message) => {
        const matchData = message?.data?.match;
        const attackData = message?.data?.attack;

        if (!matchData) {
          return;
        }

        if (attackData) {
          setAttackResponse({ ...matchData, attack: attackData });
        } else {
          setAttackResponse(matchData);
        }

        setInGameMessage({
          ...matchData,
          egg_piece_type: message?.data?.egg_piece_type,
          egg_piece_id: message?.data?.egg_piece_id,
        });
        const redStatus = matchData?.red_status;
        const blueStatus = matchData?.blue_status;
        if (
          redStatus === "build_lineup_done" &&
          accountV2?.data?.id === matchData?.red_user_id
        ) {
          setYouReady(true);
        }
        if (
          blueStatus === "build_lineup_done" &&
          accountV2?.data?.id === matchData?.blue_user_id
        ) {
          setYouReady(true);
        }
      },
    )
      .then(() => {})
      .catch((error) => {
        console.error("Subscription failed:", error);
      });
  };

  const handleStartMatchmaking = () => {
    ws.startMatchmaking({
      id: Date.now(),
      method: "start-matchmaking",
      params: [roomType?.id],
    })
      .then(async (response) => {
        if (response?.code !== 0) {
          toast.info(response?.message, {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 2000,
            toastId: response?.message,
          });
          await sleep(2000);
          navigate(navPaths.BATTLE_ONLINE);
        }
        // setCurrentState(response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // useEffect(() => {
  //   if (
  //     match?.current_match?.red_user_id &&
  //     match?.current_match?.blue_user_id
  //   ) {
  //     setMatchFound(
  //       accountV2?.data?.id === match?.current_match?.red_user_id ||
  //         accountV2?.data?.id === match?.current_match?.blue_user_id,
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   accountV2?.data?.id,
  //   match?.current_match?.blue_user_id,
  //   match?.current_match?.red_user_id,
  // ]);

  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const startCountdown = async () => {
      for (let i = 0; i < 5; i++) {
        await sleep(1000);
        setCountdown((countdown) => countdown - 1);
        if (i === 4) {
          setMatchMaking(false);
        }
      }
    };
    if (allPlayerAccepted) {
      setCountdown(3);
      startCountdown();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allPlayerAccepted, setMatchMaking]);

  const users = useBirdBattle((state: any) => state.users);
  const updateUsers = useBirdBattle((state: any) => state.updateUsers);

  const handleGetUserInfoFrens = async () => {
    try {
      const rsInfo = await ws.getInfo(Date.now() + 1, [accountV2?.data?.id]);
      const newUserInfo = [...users];
      newUserInfo.push({
        ...rsInfo?.data,
        userId: accountV2?.data?.id,
      });
      updateUsers(newUserInfo);
    } catch (error) {
      console.error("Error fetching info:", error);
    }
  };

  const handleGetUserInfo = async (currentMatch: any) => {
    try {
      const rsRed = await ws.getInfo(Date.now() + 1, [
        currentMatch?.red_user_id || currentMatch?.creator_id,
      ]);
      const rsBlue = await ws.getInfo(Date.now() + 2, [
        currentMatch?.blue_user_id || currentMatch?.guest_id,
      ]);

      const newUserInfo = [];
      newUserInfo.push(
        {
          ...rsRed?.data,
          userId: currentMatch?.red_user_id || currentMatch?.creator_id,
        },
        {
          ...rsBlue?.data,
          userId: currentMatch?.blue_user_id || currentMatch?.guest_id,
        },
      );
      updateUsers(newUserInfo);
    } catch (error) {
      console.error("Error fetching info:", error);
    }
  };

  const handleReadyFrensBattle = (cancel?: boolean) => {
    ws.readyFrensBattle({
      id: Date.now(),
      method: cancel ? "cancel-ready" : "ready",
      params: [joinRoomCode || match?.code],
    })
      .then(async (response) => {
        if (response?.code !== 0) {
          toast.info(response?.message, {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 2000,
            toastId: response?.message,
          });
          await sleep(2000);
          navigate(navPaths.BATTLE_HOME);
        }
        setGuestReady((prev) => !prev);
        // setCurrentState(response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleStartFrensBattle = () => {
    ws.startFrensBattle({
      id: Date.now(),
      method: "start-match",
      params: [match?.code],
    })
      .then(async (response) => {
        if (response?.code !== 0) {
          toast.info(response?.message, {
            style: { maxWidth: 337, height: 40, borderRadius: 8 },
            autoClose: 2000,
            toastId: response?.message,
          });
          await sleep(2000);
          navigate(navPaths.BATTLE_HOME);
        }
        // setCurrentState(response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [guestReady, setGuestReady] = useState<boolean>(false);

  const handlePlayWithFrens = async () => {
    if (!match?.code) {
      return;
    }
    if (!match?.guest_id) {
      const inviteToRoom =
        "Challenge%20accepted%3F%20Join%20me%20in%20Battle%20SEED%20and%20let%E2%80%99s%20see%20who%20comes%20out%20on%20top%21%20%F0%9F%92%A5";
      tele.openTelegramLink(
        `https://t.me/share/url?url=${
          process.env.REACT_APP_BOT_URL
        }startapp=u=${String(tele.initDataUnsafe?.user?.id)}_b=${
          match?.code
        }&text=${inviteToRoom}`,
      );
      return;
    }
    if (accountV2?.data?.id === match?.guest_id && !guestReady) {
      handleReadyFrensBattle();
      return;
    }
    if (accountV2?.data?.id === match?.guest_id && guestReady) {
      handleReadyFrensBattle(true);
      return;
    }
    if (accountV2?.data?.id === match?.creator_id && match?.guest_ready) {
      handleStartFrensBattle();
      return;
    }
  };

  const [isShowLeaveRoomModal, setIsShowLeaveRoomModal] =
    useState<boolean>(false);

  return (
    <>
      {match ? (
        <>
          {/* PLAY ONLINE */}
          {!playWithFrens && allPlayerAccepted && users.length > 0 && (
            <div className="h-full flex flex-col items-center justify-evenly relative z-10">
              <div className="invisible">1</div>
              <div className="w-full flex flex-col items-center">
                <PlayerItem
                  player={{
                    ...match,
                    username: users[0]?.name,
                    win: users[0]?.won_count,
                    lose: users[0]?.lost_count,
                  }}
                />
                <div
                  className="bg-cover bg-no-repeat bg-center size-[168px] max-h-[168px]"
                  style={{
                    backgroundImage: `url("/images/battle_bird/vs.png")`,
                  }}
                ></div>
                <PlayerItem
                  player={{
                    ...match,
                    username: users[1]?.name,
                    win: users[1]?.won_count,
                    lose: users[1]?.lost_count,
                  }}
                />
              </div>
              <div
                className={clsx(
                  "font-baloo-paaji uppercase text-[36px] drop-shadow-[0_2px_2px_#053C00] text-white font-bold",
                  countdown >= 0 ? "animate-bounce" : "animate-ping",
                )}
              >
                {countdown < 0 ? "Ready" : countdown}
              </div>
            </div>
          )}
          {/* PLAY WITH FRENS */}
          {playWithFrens && users.length > 0 && (
            <div className="h-full flex flex-col items-center justify-evenly relative z-10">
              <div className="mb-3 lsm:mb-6 text-center text-[#fff] w-[272px]">
                <p className="text-[40px] font-black font-baloo-paaji text-baloo-border drop-shadow-[0_2px_2px_#053C00] uppercase">
                  Private Room
                </p>
                <div className="flex items-center justify-center gap-1">
                  <p className="font-medium">Room code:</p>
                  <p className="font-black font-baloo-paaji text-baloo-border text-[24px] mt-[3px]">
                    {match?.code}
                  </p>
                </div>
              </div>
              <div className="w-full flex flex-col items-center">
                <PlayerItem
                  player={{
                    ...match,
                    username: users[0]?.name,
                    win: users[0]?.won_count,
                    lose: users[0]?.lost_count,
                  }}
                />
                <div
                  className="bg-cover bg-no-repeat bg-center size-[168px] max-h-[168px]"
                  style={{
                    backgroundImage: `url("/images/battle_bird/vs.png")`,
                  }}
                ></div>
                <PlayerItem
                  player={{
                    ...match,
                    username: users[1]?.name,
                    win: users[1]?.won_count,
                    lose: users[1]?.lost_count,
                    guest: match?.guest_id,
                    ready: match?.guest_ready || guestReady,
                  }}
                />
              </div>

              <div className="flex flex-col items-center gap-4">
                <div className="flex items-center gap-4">
                  <div className="max-w-[140px]">
                    <BaseBtn
                      className="bg-white/10 border-white"
                      onClick={() => setIsShowLeaveRoomModal(true)}
                    >
                      <div className="py-1 px-6 font-black font-baloo-paaji text-baloo-border drop-shadow-[0_2px_2px_#053C00] text-white text-[24px] normal-case">
                        Leave
                      </div>
                    </BaseBtn>
                  </div>
                  <div className="max-w-[140px]">
                    <BaseBtn
                      onClick={handlePlayWithFrens}
                      className={
                        match?.creator_id &&
                        match?.guest_id &&
                        accountV2?.data?.id === match?.creator_id &&
                        !match?.guest_ready &&
                        "bg-[#B3B3B3] !border-[#606060] !shadow-[0_3.5px_0.5px_#606060] pointer-events-none"
                      }
                    >
                      {match?.code && !match?.guest_id && (
                        <div className="flex items-center justify-center py-1 px-6 gap-2">
                          <div>
                            <svg
                              width="28"
                              height="26"
                              viewBox="0 0 28 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g filter="url(#filter0_d_8814_907)">
                                <mask
                                  id="path-1-outside-1_8814_907"
                                  maskUnits="userSpaceOnUse"
                                  x="2"
                                  y="-0.5"
                                  width="25"
                                  height="23"
                                  fill="black"
                                >
                                  <rect
                                    fill="white"
                                    x="2"
                                    y="-0.5"
                                    width="25"
                                    height="23"
                                  />
                                  <path d="M17 9.75H15.1641C13.4062 9.75 12 11.1953 12 12.9531C12 13.8125 12.3906 14.2812 12.7422 14.5156C13.0156 14.7109 13.25 14.9844 13.25 15.3359C13.25 15.7266 12.9375 16.0391 12.5469 16.0391H12.4297C12.3516 16.0391 12.2344 16 12.1562 15.9609C11.4531 15.6484 8.25 14.0469 8.25 10.375C8.25 7.28906 10.75 4.75 13.875 4.75H17V2.36719C17 1.625 17.5859 1 18.3281 1C18.6797 1 18.9922 1.15625 19.2266 1.35156L24.6562 6.23438C24.9297 6.50781 25.125 6.85938 25.125 7.25C25.125 7.67969 24.9297 8.03125 24.6562 8.30469L19.2266 13.1875C18.9922 13.4219 18.6797 13.5 18.3672 13.5H18.25C17.5469 13.5 17 12.9531 17 12.25V9.75ZM6.375 4.75C6.02344 4.75 5.75 5.0625 5.75 5.375V17.875C5.75 18.2266 6.02344 18.5 6.375 18.5H18.875C19.1875 18.5 19.5 18.2266 19.5 17.875V16C19.5 15.3359 20.0469 14.75 20.75 14.75C21.4141 14.75 22 15.3359 22 16V17.875C22 19.6328 20.5938 21 18.875 21H6.375C4.61719 21 3.25 19.6328 3.25 17.875V5.375C3.25 3.65625 4.61719 2.25 6.375 2.25H8.25C8.91406 2.25 9.5 2.83594 9.5 3.5C9.5 4.20312 8.91406 4.75 8.25 4.75H6.375Z" />
                                </mask>
                                <path
                                  d="M17 9.75H15.1641C13.4062 9.75 12 11.1953 12 12.9531C12 13.8125 12.3906 14.2812 12.7422 14.5156C13.0156 14.7109 13.25 14.9844 13.25 15.3359C13.25 15.7266 12.9375 16.0391 12.5469 16.0391H12.4297C12.3516 16.0391 12.2344 16 12.1562 15.9609C11.4531 15.6484 8.25 14.0469 8.25 10.375C8.25 7.28906 10.75 4.75 13.875 4.75H17V2.36719C17 1.625 17.5859 1 18.3281 1C18.6797 1 18.9922 1.15625 19.2266 1.35156L24.6562 6.23438C24.9297 6.50781 25.125 6.85938 25.125 7.25C25.125 7.67969 24.9297 8.03125 24.6562 8.30469L19.2266 13.1875C18.9922 13.4219 18.6797 13.5 18.3672 13.5H18.25C17.5469 13.5 17 12.9531 17 12.25V9.75ZM6.375 4.75C6.02344 4.75 5.75 5.0625 5.75 5.375V17.875C5.75 18.2266 6.02344 18.5 6.375 18.5H18.875C19.1875 18.5 19.5 18.2266 19.5 17.875V16C19.5 15.3359 20.0469 14.75 20.75 14.75C21.4141 14.75 22 15.3359 22 16V17.875C22 19.6328 20.5938 21 18.875 21H6.375C4.61719 21 3.25 19.6328 3.25 17.875V5.375C3.25 3.65625 4.61719 2.25 6.375 2.25H8.25C8.91406 2.25 9.5 2.83594 9.5 3.5C9.5 4.20312 8.91406 4.75 8.25 4.75H6.375Z"
                                  fill="white"
                                />
                                <path
                                  d="M17 9.75H18V8.75H17V9.75ZM12.7422 14.5156L13.3234 13.7019L13.3103 13.6925L13.2969 13.6836L12.7422 14.5156ZM12.1562 15.9609L12.6035 15.0665L12.5831 15.0564L12.5624 15.0471L12.1562 15.9609ZM17 4.75V5.75H18V4.75H17ZM19.2266 1.35156L19.8952 0.608002L19.8812 0.595403L19.8667 0.583341L19.2266 1.35156ZM24.6562 6.23438L25.3634 5.52727L25.3446 5.50853L25.3249 5.49081L24.6562 6.23438ZM24.6562 8.30469L25.3249 9.04825L25.3446 9.03053L25.3634 9.01179L24.6562 8.30469ZM19.2266 13.1875L18.5579 12.4439L18.5382 12.4617L18.5195 12.4804L19.2266 13.1875ZM17 8.75H15.1641V10.75H17V8.75ZM15.1641 8.75C12.8381 8.75 11 10.6591 11 12.9531H13C13 11.7316 13.9744 10.75 15.1641 10.75V8.75ZM11 12.9531C11 14.1726 11.5799 14.9426 12.1875 15.3477L13.2969 13.6836C13.235 13.6423 13.1669 13.579 13.1126 13.4817C13.0602 13.3878 13 13.2255 13 12.9531H11ZM12.1609 15.3294C12.1951 15.3538 12.2215 15.3759 12.2407 15.3947C12.2601 15.4134 12.2688 15.4253 12.2712 15.4287C12.2731 15.4316 12.2674 15.4238 12.2612 15.4054C12.2545 15.3856 12.25 15.3613 12.25 15.3359H14.25C14.25 14.5018 13.6951 13.9674 13.3234 13.7019L12.1609 15.3294ZM12.25 15.3359C12.25 15.1743 12.3852 15.0391 12.5469 15.0391V17.0391C13.4898 17.0391 14.25 16.2788 14.25 15.3359H12.25ZM12.5469 15.0391H12.4297V17.0391H12.5469V15.0391ZM12.4297 15.0391C12.4884 15.0391 12.5297 15.0459 12.5462 15.0489C12.5653 15.0524 12.5768 15.0558 12.5803 15.0568C12.5844 15.0581 12.5893 15.0594 12.6035 15.0665L11.709 16.8554C11.8438 16.9227 12.125 17.0391 12.4297 17.0391V15.0391ZM12.5624 15.0471C11.8803 14.744 9.25 13.3807 9.25 10.375H7.25C7.25 14.7131 11.0259 16.5529 11.7501 16.8747L12.5624 15.0471ZM9.25 10.375C9.25 7.83682 11.3068 5.75 13.875 5.75V3.75C10.1932 3.75 7.25 6.74131 7.25 10.375H9.25ZM13.875 5.75H17V3.75H13.875V5.75ZM18 4.75V2.36719H16V4.75H18ZM18 2.36719C18 2.1392 18.1756 2 18.3281 2V0C16.9963 0 16 1.1108 16 2.36719H18ZM18.3281 2C18.3801 2 18.4739 2.02603 18.5864 2.11978L19.8667 0.583341C19.5105 0.286472 18.9792 0 18.3281 0V2ZM18.5579 2.09512L23.9876 6.97793L25.3249 5.49081L19.8952 0.608002L18.5579 2.09512ZM23.9491 6.94148C24.1 7.09237 24.125 7.20419 24.125 7.25H26.125C26.125 6.51456 25.7593 5.92325 25.3634 5.52727L23.9491 6.94148ZM24.125 7.25C24.125 7.34863 24.0874 7.45933 23.9491 7.59758L25.3634 9.01179C25.772 8.60317 26.125 8.01075 26.125 7.25H24.125ZM23.9876 7.56113L18.5579 12.4439L19.8952 13.9311L25.3249 9.04825L23.9876 7.56113ZM18.5195 12.4804C18.5244 12.4754 18.5267 12.4774 18.5099 12.483C18.4883 12.4902 18.4431 12.5 18.3672 12.5V14.5C18.8338 14.5 19.4456 14.3827 19.9337 13.8946L18.5195 12.4804ZM18.3672 12.5H18.25V14.5H18.3672V12.5ZM18.25 12.5C18.1642 12.5 18.1059 12.469 18.0684 12.4316C18.031 12.3941 18 12.3358 18 12.25H16C16 13.5054 16.9946 14.5 18.25 14.5V12.5ZM18 12.25V9.75H16V12.25H18ZM6.375 3.75C5.43147 3.75 4.75 4.55075 4.75 5.375H6.75C6.75 5.50436 6.69858 5.58929 6.65265 5.63722C6.60099 5.69112 6.50549 5.75 6.375 5.75V3.75ZM4.75 5.375V17.875H6.75V5.375H4.75ZM4.75 17.875C4.75 18.7788 5.47115 19.5 6.375 19.5V17.5C6.46495 17.5 6.56291 17.5374 6.63777 17.6122C6.71264 17.6871 6.75 17.785 6.75 17.875H4.75ZM6.375 19.5H18.875V17.5H6.375V19.5ZM18.875 19.5C19.6992 19.5 20.5 18.8185 20.5 17.875H18.5C18.5 17.7445 18.5589 17.649 18.6128 17.5973C18.6607 17.5514 18.7456 17.5 18.875 17.5V19.5ZM20.5 17.875V16H18.5V17.875H20.5ZM20.5 16C20.5 15.9438 20.524 15.8786 20.576 15.8254C20.625 15.7754 20.6848 15.75 20.75 15.75V13.75C19.4744 13.75 18.5 14.804 18.5 16H20.5ZM20.75 15.75C20.7858 15.75 20.8518 15.768 20.9169 15.8331C20.982 15.8982 21 15.9642 21 16H23C23 14.7837 21.9663 13.75 20.75 13.75V15.75ZM21 16V17.875H23V16H21ZM21 17.875C21 19.0724 20.0496 20 18.875 20V22C21.1379 22 23 20.1932 23 17.875H21ZM18.875 20H6.375V22H18.875V20ZM6.375 20C5.16947 20 4.25 19.0805 4.25 17.875H2.25C2.25 20.1851 4.0649 22 6.375 22V20ZM4.25 17.875V5.375H2.25V17.875H4.25ZM4.25 5.375C4.25 4.20035 5.17762 3.25 6.375 3.25V1.25C4.05676 1.25 2.25 3.11215 2.25 5.375H4.25ZM6.375 3.25H8.25V1.25H6.375V3.25ZM8.25 3.25C8.2858 3.25 8.35183 3.26799 8.41692 3.33308C8.48201 3.39817 8.5 3.4642 8.5 3.5H10.5C10.5 2.28365 9.46635 1.25 8.25 1.25V3.25ZM8.5 3.5C8.5 3.56523 8.47464 3.62499 8.42456 3.674C8.37143 3.726 8.30618 3.75 8.25 3.75V5.75C9.44596 5.75 10.5 4.77558 10.5 3.5H8.5ZM8.25 3.75H6.375V5.75H8.25V3.75Z"
                                  fill="#0B8B00"
                                  mask="url(#path-1-outside-1_8814_907)"
                                />
                              </g>
                              <defs>
                                <filter
                                  id="filter0_d_8814_907"
                                  x="0.71"
                                  y="0.238"
                                  width="26.955"
                                  height="25.08"
                                  filterUnits="userSpaceOnUse"
                                  color-interpolation-filters="sRGB"
                                >
                                  <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                  />
                                  <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                  />
                                  <feOffset dy="1.778" />
                                  <feGaussianBlur stdDeviation="1.27" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0.0187383 0 0 0 0 0.236784 0 0 0 0 0 0 0 0 1 0"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_8814_907"
                                  />
                                  <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_8814_907"
                                    result="shape"
                                  />
                                </filter>
                              </defs>
                            </svg>
                          </div>
                          <span className="font-black font-baloo-paaji text-baloo-border drop-shadow-[0_2px_2px_#053C00] text-[24px] uppercase">
                            Invite
                          </span>
                        </div>
                      )}
                      {accountV2?.data?.id === match?.guest_id && (
                        <div className="flex items-center justify-center py-1 px-6 gap-2">
                          <span className="font-black font-baloo-paaji text-baloo-border drop-shadow-[0_2px_2px_#053C00] text-[24px] uppercase">
                            {!guestReady ? "Ready" : "Cancel"}
                          </span>
                        </div>
                      )}
                      {match?.creator_id &&
                        match?.guest_id &&
                        accountV2?.data?.id === match?.creator_id && (
                          <div className="flex items-center justify-center py-1 px-6 gap-2">
                            <span
                              className={clsx(
                                "font-black font-baloo-paaji text-[24px] uppercase",
                                !match?.guest_ready
                                  ? "text-[#515151] text-baloo-border-none"
                                  : "text-baloo-border drop-shadow-[0_2px_2px_#053C00]",
                              )}
                            >
                              {"Start"}
                            </span>
                            {match?.guest_ready && (
                              <div className="-mr-1">
                                <svg
                                  width="21"
                                  height="24"
                                  viewBox="0 0 21 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g filter="url(#filter0_d_8864_1410)">
                                    <mask
                                      id="path-1-outside-1_8864_1410"
                                      maskUnits="userSpaceOnUse"
                                      x="1.82812"
                                      y="-0.69043"
                                      width="18"
                                      height="21"
                                      fill="black"
                                    >
                                      <rect
                                        fill="white"
                                        x="1.82812"
                                        y="-0.69043"
                                        width="18"
                                        height="21"
                                      />
                                      <path d="M16.9297 8.20801C17.5026 8.59863 17.8021 9.13249 17.8281 9.80957C17.8021 10.5127 17.5026 11.0335 16.9297 11.3721L5.67969 18.2471C5.05469 18.6377 4.42969 18.6637 3.80469 18.3252C3.17969 17.9606 2.85417 17.4137 2.82812 16.6846V2.93457C2.85417 2.2054 3.17969 1.65853 3.80469 1.29395C4.42969 0.955404 5.05469 0.968424 5.67969 1.33301L16.9297 8.20801Z" />
                                    </mask>
                                    <path
                                      d="M16.9297 8.20801C17.5026 8.59863 17.8021 9.13249 17.8281 9.80957C17.8021 10.5127 17.5026 11.0335 16.9297 11.3721L5.67969 18.2471C5.05469 18.6377 4.42969 18.6637 3.80469 18.3252C3.17969 17.9606 2.85417 17.4137 2.82812 16.6846V2.93457C2.85417 2.2054 3.17969 1.65853 3.80469 1.29395C4.42969 0.955404 5.05469 0.968424 5.67969 1.33301L16.9297 8.20801Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M16.9297 8.20801L17.493 7.38178L17.4724 7.36773L17.4511 7.35473L16.9297 8.20801ZM17.8281 9.80957L18.8274 9.84658L18.8288 9.80886L18.8274 9.77114L17.8281 9.80957ZM16.9297 11.3721L16.421 10.5111L16.4146 10.5149L16.4082 10.5188L16.9297 11.3721ZM5.67969 18.2471L5.15821 17.3937L5.14969 17.3991L5.67969 18.2471ZM3.80469 18.3252L3.30082 19.189L3.31449 19.1969L3.3284 19.2045L3.80469 18.3252ZM2.82812 16.6846H1.82812V16.7024L1.82876 16.7203L2.82812 16.6846ZM2.82812 2.93457L1.82876 2.89888L1.82812 2.91672V2.93457H2.82812ZM3.80469 1.29395L3.3284 0.414653L3.31449 0.422192L3.30082 0.430166L3.80469 1.29395ZM5.67969 1.33301L6.20114 0.479726L6.1924 0.474387L6.18356 0.469229L5.67969 1.33301ZM16.3664 9.03424C16.6845 9.25115 16.8153 9.49642 16.8289 9.848L18.8274 9.77114C18.7888 8.76856 18.3207 7.94611 17.493 7.38178L16.3664 9.03424ZM16.8288 9.77256C16.8145 10.1589 16.6811 10.3574 16.421 10.5111L17.4384 12.233C18.3241 11.7096 18.7897 10.8665 18.8274 9.84658L16.8288 9.77256ZM16.4082 10.5188L5.15824 17.3938L6.20114 19.1004L17.4511 12.2254L16.4082 10.5188ZM5.14969 17.3991C4.81609 17.6076 4.57518 17.6053 4.28097 17.4459L3.3284 19.2045C4.28419 19.7222 5.29329 19.6678 6.20969 19.0951L5.14969 17.3991ZM4.30856 17.4614C3.98281 17.2714 3.84141 17.0388 3.82749 16.6489L1.82876 16.7203C1.86692 17.7887 2.37657 18.6498 3.30082 19.189L4.30856 17.4614ZM3.82812 16.6846V2.93457H1.82812V16.6846H3.82812ZM3.82749 2.97026C3.84141 2.58032 3.98281 2.34774 4.30856 2.15772L3.30082 0.430166C2.37657 0.969313 1.86692 1.83049 1.82876 2.89888L3.82749 2.97026ZM4.28097 2.17324C4.59225 2.00463 4.84578 2.00426 5.17582 2.19679L6.18356 0.469229C5.2636 -0.0674155 4.26713 -0.0938209 3.3284 0.414653L4.28097 2.17324ZM5.15824 2.18629L16.4082 9.06129L17.4511 7.35473L6.20114 0.479726L5.15824 2.18629Z"
                                      fill="#0B8B00"
                                      mask="url(#path-1-outside-1_8864_1410)"
                                    />
                                  </g>
                                  <defs>
                                    <filter
                                      id="filter0_d_8864_1410"
                                      x="0.288125"
                                      y="0.0241328"
                                      width="20.08"
                                      height="23.1269"
                                      filterUnits="userSpaceOnUse"
                                      color-interpolation-filters="sRGB"
                                    >
                                      <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                      />
                                      <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                      />
                                      <feOffset dy="1.778" />
                                      <feGaussianBlur stdDeviation="1.27" />
                                      <feComposite
                                        in2="hardAlpha"
                                        operator="out"
                                      />
                                      <feColorMatrix
                                        type="matrix"
                                        values="0 0 0 0 0.0187383 0 0 0 0 0.236784 0 0 0 0 0 0 0 0 1 0"
                                      />
                                      <feBlend
                                        mode="normal"
                                        in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8864_1410"
                                      />
                                      <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_dropShadow_8864_1410"
                                        result="shape"
                                      />
                                    </filter>
                                  </defs>
                                </svg>
                              </div>
                            )}
                          </div>
                        )}
                    </BaseBtn>
                  </div>
                </div>
                {/* {match?.code && !match?.guest_id && (
                  <p className="text-sm text-white">
                    Or invite Friends from the list below
                  </p>
                )} */}
              </div>
              <div
                className={clsx(
                  "fixed inset-0 flex items-center justify-center transition-all ease-linear z-50 bg-[#000000CC] backdrop-blur-sm",
                  allFriendsReady ? "translate-y-0" : "translate-y-[100%]",
                )}
              >
                <div
                  className={clsx(
                    "font-baloo-paaji uppercase text-[36px] drop-shadow-[0_2px_2px_#053C00] text-white font-bold flex flex-col items-center gap-1",
                  )}
                >
                  Starting
                  <div className="game-loader"></div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="h-full flex flex-col items-center justify-center gap-3 relative z-10">
            <p className="font-baloo-paaji uppercase text-[32px] drop-shadow-[0_2px_2px_#053C00] text-white font-bold">
              {joinRoomCode
                ? "Joining Room"
                : playWithFrens
                ? "Creating Room"
                : "Matchmaking"}
            </p>
            {/* <div className="battle_loader"></div> */}
            <div className="game-loader mt-3"></div>
            {!playWithFrens && <StopWatch />}
          </div>
        </>
      )}
      <div className="absolute inset-0 backdrop-blur-sm bg-[#00000066]" />
      <ModalContainer>
        {isShowLeaveRoomModal && (
          <ConfirmLeaveRoomModal
            handleClose={() => setIsShowLeaveRoomModal(false)}
            handleLeaveRoom={() => handleLeaveRoom(match?.code)}
          />
        )}
      </ModalContainer>
    </>
  );
};

export default PublicMatchMaking;
